import { auth, googleProvider, twitterProvider, dbUserProfile, dbClient } from '../firebase';
import { GET_USER, USER_STATUS, USER_PROFILE_LOADED, USER_LOGOUT, CLIENT_LOADED } from '../actionTypes';

export function getUser() {
  return dispatch => {
    // show loading status before getting user to true
    dispatch({
      type: USER_STATUS,
      payload: true
    });
    auth.onAuthStateChanged(user => {
      dispatch({
        type: GET_USER,
        payload: user
      });
      // show loading status to false
      dispatch({
        type: USER_STATUS,
        payload: false
      });
    });
  };
}

export function getUserProfile() {
  return dispatch => {
    dbUserProfile.child(auth.currentUser.uid).on(
      'value',
      snapshot => {
        dbClient.child(snapshot.val().client).on(
          'value',
          snapshot => {
            dispatch({
                type: CLIENT_LOADED,
                payload: snapshot.val()
            });

          },
          () => {

          }
        );

        dispatch({
            type: USER_PROFILE_LOADED,
            payload: snapshot.val()
        });
      },
      () => {

      }
    );
  };
}


export function emailLogin(email, password) {
  return dispatch => auth.signInWithPopup(googleProvider);
}

export function googleLogin() {
  return dispatch => auth.signInWithPopup(googleProvider);
}

export function twitterLogin() {
  return dispatch => auth.signInWithPopup(twitterProvider);
}

export function logout() {
  return dispatch => {
    dispatch({
      type: USER_LOGOUT,
      payload: true
    });
    auth.signOut();
  }
}



// WEBPACK FOOTER //
// ./src/actions/userAction.js